import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerArchivoBimOperacionService = async (values) => {
    try {
        return await instance.Backend.post("/Hallazgo/ObtenerArchivoBimOperacion",values, customConfig);
    } catch (error) {
        console.log(error);
    }
}
export { ObtenerArchivoBimOperacionService };